import React, { useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux'
import moment from 'moment';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import HighstocksComponent from '../../components/Highstocks/HighstocksComponent';
import { useHistory } from "react-router-dom";
import {
  selectedDateRange,
  changeRangeDate,
  AdminState,
  changeSearch,
  changeTabs,
  getAllResults,
  setStatus,
  changeComment,
  addNewLogMessage
} from './AdminPageActions';
import { Statistic, Icon, Card, Grid, Progress, Breadcrumb, Button, Input, Search, Accordion, Badge } from '@scuf/common';
import baseServices from "../../services/base.services";
import { Chart, Gauge, CircleGauge } from '@scuf/charts';
import Pareto from '../../components/Charts/Pareto/Pareto';
import UseTimeSeries from '../../customHook/useTimeSeries';
import UseSelectedDiv from '../../customHook/useSelectedDiv';

import UseSparkline from '../../customHook/useSparkLine';
import SparkLineComponent from '../../components/Charts/SparkLine/SparkLineComponent';
import TimeSeriesComponent from '../../components/TimeSeries/TimeSeriesComponent';
import UseTabs from '../../customHook/useTabs';
import UseDateRange from '../../customHook/useDateRange';
import LineChart from '../../components/LineChart';

import styles from './AdminPageStyle.scss';
import MessageInfoComponent from '../../components/MessageInfo/MessageInfoComponent';


export interface PropsDetailDataList {
  title: any | null;
  value: any | null;
  icon: any | null;
}

export const DetailDataList = (data: PropsDetailDataList) => {
  return <div style={{ padding: '5px' }}>
    <div className='text-center border-gray' style={{ padding: '0px', width: '100%' }}>
      <div style={{
        position: 'absolute',
        marginLeft: '20px',
        fontSize: '30px',
        marginTop: '7px',
        color: '#1792e5'
      }}>{data.icon}</div>
      <span style={{
        fontSize: '15px', fontWeight: 700, marginRight: '5px',
        marginLeft: '5px'

      }}
      >{data.value}</span>
      <span className='title'>
        <span style={{ textTransform: 'uppercase', fontSize: '10px' }}></span>
      </span>
      <div style={{ fontSize: '7px' }}>{data.title}</div>
    </div>
  </div>
}

export const CircularChart = (data: any) => {

  return <div style={{ height: '150px', paddingLeft: '10px', paddingRight: '10px', paddingTop: '10px', paddingBottom: '20px' }}><Chart height='150'
    colors={['#28a745', '#dc3546', 'gray']}>
    {/*@ts-ignore */}
    <Chart.Donut
      data={[
        { name: '80% - Correct time', y: 80 },
        { name: '20% -Deviated time', y: 100 - 80 },
      ]}
    >
      <Chart.CenterBlock>

      </Chart.CenterBlock>
    </Chart.Donut>
    < Chart.Legend enabled={true} position='right middle'></Chart.Legend>
  </Chart>
  </div>
}

function AdminPage(propsPage: AdminState | null) {
  const selectedRange = useAppSelector(selectedDateRange);
  const history: any = useHistory();
  const [reload, setReload] = useState(false);
  {/* @ts-ignore */ }

  const dispatch = useAppDispatch();

  const handlerStatus = (item: any) => {
    dispatch(setStatus({idComment: item.idComment, status: item.status}))
    dispatch(getAllResults({ period: propsPage?.selectedRange }))
    setReload(!reload);
  }

  const handlerSendComment = (item: any) => {
    dispatch(addNewLogMessage({item: item, LogMessage: propsPage?.comment}))
    setReload(!reload);
  }

  const handlerSelectedTabs = (data: any) => {
    dispatch(changeTabs(data));
    setReload(!reload);
   // dispatch(getAllResults({ processID: data.id, period: propsPage?.selectedRange }))
  }

  const handlerDate = (data: any) => {
    dispatch(changeRangeDate(data.id));

    dispatch(getAllResults({ period: data.id }))
    setReload(!reload);
    
  }


  useEffect(() => {
    dispatch(getAllResults({ period: propsPage?.selectedRange }))
  }, [])


  return (
    <Grid>
      <Grid.Row >
        <h4 className='title-page'> HOME</h4>
        <div className='title-tab'></div>
      </Grid.Row>
      <Grid.Row>

        <Grid.Column width={4} sWidth={12}>

        </Grid.Column>

        <Grid.Column width={4} sWidth={12}>

        </Grid.Column>
        <Grid.Column width={4} sWidth={12} className='justify-content-center align-self-center text-center' >
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={5} sWidth={12} className='d-flex align-items-center'>
          <div style={{ marginBottom: '10px' }}>
            <UseTabs callback={handlerSelectedTabs} tabs={[{ id: 1, title: '1. RECIBIDO' }, { id: 2, title: '2. ANALIZANDO' }, { id: 3, title: '3. DEFINICIÓN' }, { id: 5, title: '4. REALIZADO' }]}></UseTabs>
          </div>
        </Grid.Column>
        <Grid.Column width={2} sWidth={12}>
          <div className='no-show-movil' style={{
            margin: '0px auto',
            //       width: '240px'
          }}>
            {/*@ts-ignore */}
            <UseDateRange callback={handlerDate}>

            </UseDateRange>
          </div>
        </Grid.Column>
        <Grid.Column width={5} sWidth={12} className='d-flex align-items-center'>
          <div style={{ textAlign: 'right', width: '100%', paddingRight: '10px', fontSize: '20px', color: '#45a7ea' }}>
            <span className='show-only-movil' style={{ marginRight: '0px', fontWeight: 700, fontSize: '18px', cursor: 'pointer' }}
              onClick={() => handlerDate({ id: propsPage?.selectedRange == 'D' ? 'W' : propsPage?.selectedRange == 'W' ? 'M' : 'D' })}>
              {propsPage?.selectedRange == 'D' ? '24H' : propsPage?.selectedRange == 'W' ? '7D' : '30D'}
            </span>
            {
              <>
                <div style={{ 
                  width: 'min-content', 
                  //display: 'contents',
                  display: 'none'}} className='no-show-movil'>
                  <Search placeholder='Search...' category={false} loading={false} onSearchChange={(value) => dispatch(changeSearch(value))} results={[]} />
                </div>

              </>
            }
          </div>
        </Grid.Column>

      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={12} sWidth={12}>
          <div style={{ marginTop: '20px' }}>
            <Card>
              <div style={{ padding: '10px' }}>
                {propsPage?.data == null ? <></>
                  : propsPage?.data.filter(y=> y.status == propsPage.selectedTabs.id).length == 0 ? <MessageInfoComponent message='No hay mensajes' height='200px'></MessageInfoComponent> :
                    propsPage?.data.filter(y=> y.status == propsPage.selectedTabs.id).map(item => {
                      return <Accordion defaultActiveIndex={999}>
                        <Accordion.Content title={<><span className='no-show-movil title-accordion'>
                          F. Act:  {item.dateUpdate}</span><span style={{marginRight:'10px'}}>{item.idComment} - {item.name} {item.lastname}</span> 
                        {/*@ts-ignore */}
                        <Badge color={item.status == 3 ? 'green' : item.status == 4 ? 'red' :'blue'}>{item.tagStatus}</Badge>
                        </>} arrowPosition="right">
                          
                          <div style={{
                            margin: '10px 0px',
                            //background: '#9191911a',
                            padding: '10px'
                          }}>
                            {item.date}  -  {item.comment}
                          </div>
                
                          {
                            item.log.map(x=>{
                              if(x.logMessage){
                                return <div style={{
                                  margin: '10px 0px',
                                  background: '#9191911a',
                                  padding: '10px'
                                }}>
                                  <span style={{fontSize:'12px', fontWeight:'bold'}}>{x.date}</span> - <span style={{fontWeight:'bold'}}>{x.name} {x.lastname}:</span>   {x.logMessage}
                                </div>
                              }else{
                                return <div style={{
                                  margin: '10px 0px',
                                  //background: '#9191911a',
                                  padding: '10px',
                                  textAlign:'center'
                                }}>
                                  <Badge color={x.status == 3 ? 'green' : x.status == 4 ? 'red' :'blue'}>CAMBIÓ A ESTADO {x.tagStatus} EL {x.date}</Badge>
                                </div>
                              }
                            })
                          }
                          <div style={{display:'flex', marginBottom:'20px'}}>
                            {/*@ts-ignore */}
                            <Input className="input-example" value={propsPage.comment}
                            placeholder="Escribe un comentario" onChange={(v)=> dispatch(changeComment(v))} />
                            <Button type="inline"   
                                                         
                                  style={{ marginTop: '10px' }}   
                                  onClick={()=>handlerSendComment(item)}
                                  content={'ENVIAR'} 
                                  disabled={propsPage?.comment == null || propsPage?.comment == ''}
                                  actionType="submit"

                                />
                          </div>
                          <hr></hr>
                          <div style={{textAlign:'right'}}>
                            { propsPage.selectedTabs.id == 2 ? 
                              <>
                                <Button type="secondary"                              
                                  style={{ marginTop: '10px' }}   
                                  onClick={()=>handlerStatus({idComment: item.idComment, status: 4})}
                                  content={'RECHAZADO'} 
                                  actionType="submit"
                                />
                                <Button type="primary"                              
                                  style={{ marginTop: '10px' }}   
                                  onClick={()=>handlerStatus({idComment: item.idComment, status: 3})}
                                  content={'APROBADO'} 
                                  actionType="submit"
                                />

                              </>
                              : propsPage.selectedTabs.id == 1 ? 
                              <Button type="primary"                              
                                style={{ marginTop: '10px' }}   
                                onClick={()=>handlerStatus({idComment: item.idComment, status: 2})}
                                content={'ANALIZAR'} 
                                
                                actionType="submit"
                              /> :
                              propsPage.selectedTabs.id == 3 ? 
                              <Button type="primary"                              
                              style={{ marginTop: '10px' }}   
                              onClick={()=>handlerStatus({idComment: item.idComment, status: 5})}
                              content={'REALIZADO'} 
                              actionType="submit"/>
                              : <></>
                            
                            }
                          </div>
                        </Accordion.Content>
                      </Accordion>
                    })
                }
              </div>
            </Card>

          </div>
        </Grid.Column>

      </Grid.Row>

    </Grid>
  );
}

const mapState = (state: any) => (state.adminPageReducer)

const mapDispatch = {
  //toggleOn: () => ({ type: 'TOGGLE_IS_ON' }),
}

const connector = connect(mapState, mapDispatch);
export default connector(AdminPage)
